import requests from "./httpService";

const CustomerServices = {
  getAllCustomers: async (body) => {
    return requests.get(`/customer`);
  },

  createCustomer: async (body) => {
    return requests.post(`/customer/create`, body);
  },


  getCustomerById: async (id) => {
    return requests.get(`/customer/${id}`);
  },

  updateCustomer: async (id, body) => {
    return requests.put(`/customer/update/${id}`, body);
  },

  deleteCustomer: async (id) => {
    return requests.put(`/customer/delete/${id}`);
  },
  updateCustomerStatus:async(id,body) =>{
    return requests.put(`/customer/status/${id}`, body);
  }
};

export default CustomerServices;
